import { api } from './api';
import { Project, ProjectCard } from '../types/api.types';

export const projectsApi = {
    getAll: (): Promise<Project[]> =>
        api.get('/site/projects').then(res => res.data),

    getById: (id: number): Promise<Project> =>
        api.get(`/site/projects/${id}`).then(res => res.data),

    getCards: (projectId: number): Promise<ProjectCard[]> =>
        api.get(`/site/projects/${projectId}/cards`).then(res => res.data),

    getAllAdmin: (): Promise<Project[]> =>
        api.get('/admin/projects').then(res => res.data),

    createWithIcon: (formData: FormData): Promise<Project> =>
        api.post('/admin/projects', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => res.data),

    getByIdAdmin: (id: number): Promise<Project> =>
        api.get(`/admin/projects/${id}`).then(res => res.data),

    create: (data: Partial<Project>): Promise<Project> =>
        api.post('/admin/projects', data).then(res => res.data),

    update: (id: number, data: Partial<Project>): Promise<Project> =>
        api.put(`/admin/projects/${id}`, data).then(res => res.data),

    delete: (id: number): Promise<void> =>
        api.delete(`/admin/projects/${id}`),

    uploadIcon: (projectId: number, file: File): Promise<Project> => {
        const formData = new FormData();
        formData.append('file', file);
        return api.post(`/admin/projects/${projectId}/icon`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => res.data);
    },

    createCard: (data: Partial<ProjectCard>): Promise<ProjectCard> =>
        api.post('/admin/cards', data).then(res => res.data),

    updateCard: (id: number, data: Partial<ProjectCard>): Promise<ProjectCard> =>
        api.put(`/admin/cards/${id}`, data).then(res => res.data),

    deleteCard: (id: number): Promise<void> =>
        api.delete(`/admin/cards/${id}`),

    uploadCardImage: (cardId: number, file: File): Promise<ProjectCard> => {
        const formData = new FormData();
        formData.append('file', file);
        return api.post(`/admin/cards/${cardId}/images`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => res.data);
    },

    deleteCardImage: (cardId: number, imageKey: string): Promise<ProjectCard> =>
        api.delete(`/admin/cards/${cardId}/images?imageKey=${imageKey}`).then(res => res.data),
};